import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import '../competitive/../header/style.css';
import { Header } from "../competitive";
import { AdminNavbar } from "../competitive";
import { API_BASE_URL, ACCESS_TOKEN_NAME } from '../../../constants/apiConstants';
import axios from 'axios';

function EditCompetitiveRole() {
    const { id } = useParams();
    const navigate = useNavigate();

    // State for form fields
    const [role, setRole] = useState("");
    const [title, setTitle] = useState("");
    const [pdcet, setPdcet] = useState("");
    const [participatingColleges, setParticipatingColleges] = useState("");
    const [examDate, setExamDate] = useState("");
    const [examLevel, setExamLevel] = useState("");
    const [applicationProcess, setApplicationProcess] = useState("");
    const [examInfo, setExamInfo] = useState("");
    const [status, setStatus] = useState("");

    useEffect(() => {
        // alert(id)
        // return false
        console.log("ffhhfhf", ACCESS_TOKEN_NAME())
        // return false
        const url = `${API_BASE_URL}/getcompetitiveExamsDataById/${id}`;

        const fetchRoleData = async () => {
            try {
                const response = await axios.get(url, {
                    headers: {
                        "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                        "Content-Type": "application/json",
                    },
                });
                console.log("shsghgshs cxcxcxcxcxxc", response)
                if (response.data.length > 0) {
                    const data = response.data[0];
                    setRole(data.role_id || "");
                    // setTitle(data.title || "");
                    setPdcet(data.pdcet || "");
                    setParticipatingColleges(data.participating_colleges || "");
                    setExamDate(data.exam_date || "");
                    setExamLevel(data.exam_level || "");
                    setApplicationProcess(data.application_process || "");
                    setExamInfo(data.exam_info || "");
                    setStatus(data.status || "");
                }
            } catch (err) {
                console.error("Error fetching data:", err);
            }
        };

        fetchRoleData();
    }, [id]);

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            // name: role,
            // title: title,
            pdcet: role,
            participating_colleges: participatingColleges,
            exam_date: examDate,
            exam_level: examLevel,
            application_process: applicationProcess,
            exam_info: examInfo,
            status: status,
        };

        axios.put(`${API_BASE_URL}/updatecompetitiveExamsDataById/${id}`, payload, {
            headers: {
                "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.status === 200) {
                    navigate("/admin/competitiveListRole");
                } else {
                    console.error("Unexpected response:", response.status);
                }
            })
            .catch((error) => {
                console.error("API Error:", error);
            });
    };

    return (
        <>
            <div>
                <Header />
                <div className="main-container">
                    <AdminNavbar />
                    <div className="main">
                        <div className="report-container">
                            <div className="report-header">
                                <h1 className="recent-Articles">Edit Competitive Exam</h1>
                            </div>
                            <div className="report-body">
                                <div className="user-form">
                                    <form onSubmit={handleSubmit}>

                                        {/* Competitive Exam Title */}
                                        {/* <div className="mb-3">
                                            <label htmlFor="title" className="form-label">Competitive Exam Title</label>
                                            <input type="text" className="form-control"
                                                id="title" name="title" 
                                                value={title} onChange={(e) => setTitle(e.target.value)}
                                            />
                                        </div> */}

                                        {/* Competitive Exam Name */}
                                        <div className="mb-3">
                                            <label htmlFor="role_name" className="form-label">Competitive Exam Name</label>
                                            <input type="text" className="form-control"
                                                id="role_name" name="role_name" 
                                                value={role} onChange={(e) => setRole(e.target.value)}
                                            />
                                        </div>
                                        {/* <div className="mb-3">
                                            <label htmlFor="pdcet" className="form-label">PDCET</label>
                                            <input type="text" className="form-control"
                                                id="pdcet" name="participating_colleges"
                                                value={pdcet} onChange={(e) => setPdcet(e.target.value)}
                                            />
                                        </div> */}
                                        {/* Participating Colleges */}
                                        <div className="mb-3">
                                            <label htmlFor="participating_colleges" className="form-label">Participating Colleges</label>
                                            <input type="text" className="form-control"
                                                id="participating_colleges" name="participating_colleges"
                                                value={participatingColleges} onChange={(e) => setParticipatingColleges(e.target.value)}
                                            />
                                        </div>

                                        {/* Exam Date */}
                                        <div className="mb-3">
                                            <label htmlFor="exam_date" className="form-label">Exam Date</label>
                                            <input type="date" className="form-control"
                                                id="exam_date" name="exam_date"
                                                value={examDate} onChange={(e) => setExamDate(e.target.value)}
                                            />
                                        </div>

                                        {/* Exam Level */}
                                        <div className="mb-3">
                                            <label htmlFor="exam_level" className="form-label">Exam Level</label>
                                            <input type="text" className="form-control"
                                                id="exam_level" name="exam_level"
                                                value={examLevel} onChange={(e) => setExamLevel(e.target.value)}
                                            />
                                        </div>

                                        {/* Application Process */}
                                        <div className="mb-3">
                                            <label htmlFor="application_process" className="form-label">Application Process</label>
                                            <textarea className="form-control"
                                                id="application_process" name="application_process"
                                                value={applicationProcess} onChange={(e) => setApplicationProcess(e.target.value)}
                                            />
                                        </div>

                                        {/* Exam Info */}
                                        <div className="mb-3">
                                            <label htmlFor="exam_info" className="form-label">Exam Info</label>
                                            <textarea className="form-control"
                                                id="exam_info" name="exam_info"
                                                value={examInfo} onChange={(e) => setExamInfo(e.target.value)}
                                            />
                                        </div>

                                        {/* Competitive Exam Status */}
                                        <div className="mb-3">
                                            <label htmlFor="status" className="form-label">Competitive Exam Status</label>
                                            <select className="form-control" id="status" value={status} onChange={(e) => setStatus(e.target.value)}>
                                                <option value="">Select Status</option>
                                                <option value="1">Active</option>
                                                <option value="0">Inactive</option>
                                            </select>
                                        </div>

                                        <button type="submit" className="btn btn-primary submit-btn">
                                            UPDATE
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EditCompetitiveRole;
